import "./../App.css";
import "./../AppMobile.css";

import React from "react";
import { encrypt, hideProcess, setLocaleApp, showProcess } from "../utils/util";

import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { Password } from "primereact/password";
import authenticateService from "../services/authenticateService";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { InputOtp } from "primereact/inputotp";
import { Dialog } from "primereact/dialog";
import userService from "../services/userService";
import { Terminal } from "primereact/terminal";
import Terms from "./terms";
import { data } from "react-router-dom";

export default class Register extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showPassword: false,
            type: "F",
            user: {},
            acceptTerms: false,
            showTermsDialog: false,
            showToken: false,
            showConfirm: false,
            token: "",
        };
    }

    componentDidMount() {
        setLocaleApp();
    }

    confirm = async (event) => {
        event.preventDefault();

        if (!this.validateDocumento(this.state.user.document)) {
            if ((this.state.type = "J")) {
                alert("CNPJ INVÁLIDO.");
            } else {
                alert("CPF INVÁLIDO.");
            }

            return;
        }

        if (this.state.user.password !== this.state.user.confirmPassword) {
            alert("SENHAS DIFERENTES.");

            return;
        }

        if (!this.state.acceptTerms) {
            alert("Você deve aceitar os termos de uso antes de prosseguir.");
            return;
        }

        try {
            showProcess();

            const response = await userService.validate(this.buildUser(this.state.user));

            if (response.status === 200) {
                this.setState({ user: response.data, showToken: true });
            }
        } catch (e) {
            alert(this.responsecodes[e.response.data]);
        }

        hideProcess();
    };

    saveUser = async () => {
        await showProcess();
        try {
            if (this.state.user.token === this.state.token) {
                const response = await userService.createCustomer(this.buildUser(this.state.user));

                this.setState({ showConfirm: true, webUserId: response.data });
            } else {
                alert("CÓDIGO INVÁLIDO.");
            }
        } catch (e) {

            if (e.response && e.response.data) {
                alert(e.response.data);
            } else {
                alert("Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.");
            }

        }
        hideProcess();
    };

    resendEmail = async () => {
        await showProcess();
        try {
            await userService.resendEmail(this.state.user.email);

            alert("Email reenviado com sucesso!");
        } catch (e) {
            alert(e);
        }
        hideProcess();
    };

    buildUser() {
        var user = this.state.user;

        user.document = user.document.replaceAll(".", "").replaceAll("/", "").replaceAll("-", "");
        user.phone = user.phone
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll(" ", "")
            .replaceAll("-", "");
        user.name = user.name.toUpperCase();
        user.email = user.email.toLowerCase();
        user.address = user.address.toUpperCase();
        user.neighborhood = user.neighborhood.toUpperCase();
        user.city = user.city.toUpperCase();
        user.state = user.state.toUpperCase();
        user.number = user.number.toUpperCase();
        user.zipCode = user.zipCode.replaceAll(".", "").replaceAll("/", "").replaceAll("-", "");

        return user;
    }

    searchAddress = async () => {
        try {
            await showProcess();

            let zipCode = this.state.user.zipCode.replace("-", "").replace(".", "");
            if (zipCode.length !== 8) {
                alert("CEP inválido. Deve conter 8 dígitos.");
                hideProcess();
                return;
            }

            var that = this;

            var response = fetch(`https://viacep.com.br/ws/${zipCode}/json/`)
                .then((response) => response.json())
                .then((data) => {
                    const state =
                        data.uf !== undefined && data.uf !== null ? data.uf.toUpperCase() : data.uf;
                    const neighborhood =
                        data.bairro !== undefined && data.bairro !== null
                            ? data.bairro.toUpperCase()
                            : data.bairro;
                    const city =
                        data.localidade !== undefined && data.localidade !== null
                            ? data.localidade.toUpperCase()
                            : data.localidade;
                    const address =
                        data.logradouro !== undefined && data.logradouro !== null
                            ? data.logradouro.toUpperCase()
                            : data.logradouro;

                    that.setState((prevState) => ({
                        user: {
                            ...prevState.user,
                            state: state,
                            neighborhood: neighborhood,
                            city: city,
                            address: address,
                        },
                    }));

                    hideProcess();
                })
                .catch((error) => {
                    alert("Erro ao buscar CEP:", error);
                    hideProcess();
                });
        } catch (e) {
            hideProcess();
        }
    };

    validateCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, "");
        if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) {
            soma += parseInt(cpf.charAt(i)) * (10 - i);
        }
        let resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(9))) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) {
            soma += parseInt(cpf.charAt(i)) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        return resto === parseInt(cpf.charAt(10));
    }

    validateCNPJ(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, "");
        if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) return false;

        tamanho++;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        return resultado === parseInt(digitos.charAt(1));
    }

    validateDocumento(valor) {
        const doc = valor.replace(/[^\d]+/g, "");
        if (doc.length === 11) {
            return this.validateCPF(doc);
        } else if (doc.length === 14) {
            return this.validateCNPJ(doc);
        } else {
            return false;
        }
    }

    render() {
        return (
            <div
                style={{
                    width: "100%",
                    padding: "0px 50px"
                }}
            >
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", marginBottom: "30px", marginTop: "30px"}}>
                    <table>                    
                        <tr>
                            <td><span className="pi pi-star" style={{fontSize: "20px", color: "var(--unnamed-color-411172)"}}></span></td>
                            <td style={{textAlign: "left"}}><label style={{fontSize: "20px", color: "var(--unnamed-color-411172)", marginLeft: "10px"}}>Consulte seu saldo</label></td>
                        </tr>
                        <tr>
                            <td><span className="pi pi-star" style={{fontSize: "20px", color: "var(--unnamed-color-411172)"}}></span></td>
                            <td style={{textAlign: "left"}}><label style={{fontSize: "20px", color: "var(--unnamed-color-411172)", marginLeft: "10px"}}>Vizualize seu histórico de compras</label></td>
                        </tr>
                        <tr>
                            <td><span className="pi pi-star" style={{fontSize: "20px", color: "var(--unnamed-color-411172)"}}></span></td>
                            <td style={{textAlign: "left"}}><label style={{fontSize: "20px", color: "var(--unnamed-color-411172)", marginLeft: "10px"}}>Pagamento rápido</label></td>
                        </tr>
                    </table>

                </div>
                
        
                <form
                    
                    onSubmit={(e) => this.confirm(e)}
                >
                    <div style={{
                            width: window.innerWidth < 768 ? "100%" : "90%",
                            padding: window.innerWidth < 768 ? "8%" : "5%",
                            display: "grid",
                            gridTemplateColumns: window.innerWidth < 1024 ? "1fr" : "1fr 1fr",
                            gap: "20px",
                        }}      
                        className="app-form-register">

                        {/** Pessoa */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Pessoa
                            </span>
                            <Dropdown
                                options={[
                                    { key: "F", label: "Física" },
                                    { key: "J", label: "Jurídica" },
                                ]}
                                value={this.state.type}
                                optionLabel="label"
                                optionValue="key"
                                onChange={(e) => this.setState({ type: e.value })}
                            />
                        </span>

                        {/** CPF / CNPJ */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                {this.state.type === "J" ? "CNPJ" : "CPF"}
                            </span>
                            <InputMask
                                required
                                mask={this.state.type === "J" ? "99.999.999/9999-99" : "999.999.999-99"}
                                value={this.state.user.document}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, document: e.target.value },
                                    }))
                                }
                            />
                        </span>

                        {/** Telefone */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Telefone
                            </span>
                            <InputMask
                                required
                                mask="(99) 99999-9999"
                                value={this.state.user.phone}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, phone: e.target.value },
                                    }))
                                }
                            />
                        </span>

                        {/** Nome ou Razão Social */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                {this.state.type === "J" ? "Razão Social" : "Nome Completo"}
                            </span>
                            <InputText
                                required
                                value={this.state.user.name}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, name: e.target.value },
                                    }))
                                }
                            />
                        </span>

                        {/** Email */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                E-mail
                            </span>
                            <InputText
                                required
                                value={this.state.user.email}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, email: e.target.value },
                                    }))
                                }
                            />
                        </span>

                        {/** Senha */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Senha
                            </span>
                            <Password
                                required
                                value={this.state.user.password}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, password: e.target.value },
                                    }))
                                }
                                style={{ width: "100%" }}
                                inputStyle={{ width: "100%" }}
                            />
                        </span>

                        {/** Confirmar Senha */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Confirmar Senha
                            </span>
                            <Password
                                required
                                value={this.state.user.confirmPassword}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, confirmPassword: e.target.value },
                                    }))
                                }
                                feedback={false}
                                style={{ width: "100%" }}
                                inputStyle={{ width: "100%" }}
                            />
                        </span>

                        {/** CEP */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                CEP
                            </span>
                            <InputMask
                                mask="99.999-999"
                                required
                                value={this.state.user.zipCode}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, zipCode: e.target.value },
                                    }))
                                }
                                onBlur={() => this.searchAddress()}
                            />
                        </span>

                        {/** RUA */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Rua
                            </span>
                            <InputText
                                required
                                value={this.state.user.address}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, address: e.target.value },
                                    }))
                                }
                            />
                        </span>

                        {/** BAIRRO */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Bairro
                            </span>
                            <InputText
                                required
                                value={this.state.user.neighborhood}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, neighborhood: e.target.value },
                                    }))
                                }
                            />
                        </span>

                        {/** CIDADE */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Cidade
                            </span>
                            <InputText
                                required
                                value={this.state.user.city}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, city: e.target.value },
                                    }))
                                }
                            />
                        </span>

                        {/** ESTADO */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Estado
                            </span>
                            <Dropdown
                                required
                                options={[
                                    "AC",
                                    "AL",
                                    "AP",
                                    "AM",
                                    "BA",
                                    "CE",
                                    "DF",
                                    "ES",
                                    "GO",
                                    "MA",
                                    "MT",
                                    "MS",
                                    "MG",
                                    "PA",
                                    "PB",
                                    "PR",
                                    "PE",
                                    "PI",
                                    "RJ",
                                    "RN",
                                    "RS",
                                    "RO",
                                    "RR",
                                    "SC",
                                    "SP",
                                    "SE",
                                    "TO",
                                ]}
                                value={this.state.user.state}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, state: e.value },
                                    }))
                                }
                            />
                        </span>

                        {/** NUMERO */}
                        <span style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <span
                                style={{
                                    color: "#7E7E7E",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Nº
                            </span>
                            <InputText
                                required
                                value={this.state.user.number}
                                onChange={(e) =>
                                    this.setState((prevState) => ({
                                        user: { ...prevState.user, number: e.target.value },
                                    }))
                                }
                            />
                        </span>

                        <table style={{ marginTop: "20px", marginBottom: "30px" }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: "16px" }}>
                                        <Checkbox
                                            required
                                            id="chkTerms"
                                            onChange={(e) => this.setState({ acceptTerms: e.checked })}
                                            checked={this.state.acceptTerms}
                                            style={{ marginRight: "8px" }}
                                        />
                                    </td>
                                    <td>
                                        <label
                                            htmlFor="chkTerms"
                                            style={{ color: "#A3A3A3", fontSize: "18px" }}
                                        >
                                            Ao marcar este campo você está concordando
                                            <br /> com os nossos{" "}
                                            <a
                                                href="#"
                                                onClick={() => this.setState({ showTermsDialog: true })}
                                                style={{
                                                    color: "#411172",
                                                    textDecoration: "underline",
                                                }}
                                            >
                                                termos de uso
                                            </a>
                                            .
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        
                    </div>

                    

                    {/** Botão */}
                    <div style={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
                        <button
                            style={{
                                width: window.innerWidth < 768 ? "100%" : "80%",
                                padding: "15px",
                                fontSize: window.innerWidth < 768 ? "18px" : "20px",
                                color: "#ffffff",
                                backgroundColor: "var(--unnamed-color-411172)",
                                borderRadius: "30px",
                            }}
                        >
                            Registrar
                        </button>
                    </div>

                </form>

                {this.state.showTermsDialog && (
                    <Terms onHide={() => this.setState({ showTermsDialog: false })} />
                )}

                {this.state.showToken && (
                    <Dialog visible={true} onHide={() => this.setState({ showToken: false })}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                            <div style={{ textAlign: "center" }}>
                                <label>
                                    Enviamos um código de confirmação para o telefone{" "}
                                    {this.state.user.phone}.<br />
                                    Por favor informe-o.
                                </label>
                            </div>
                            <div style={{ marginTop: "25px" }}>
                                <InputOtp
                                    value={this.state.token}
                                    length={6}
                                    onChange={(e) => this.setState({ token: e.value })}
                                />
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    textAlign: "center",
                                    marginTop: "25px",
                                }}
                            >
                                <button
                                    style={{
                                        width: window.innerWidth < 768 ? "100%" : "80%",
                                        padding: "15px",
                                        fontSize: window.innerWidth < 768 ? "18px" : "20px",
                                        color: "#ffffff",
                                        backgroundColor: "var(--unnamed-color-411172)",
                                        borderRadius: "30px",
                                    }}
                                    onClick={() => this.saveUser()}
                                >
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}

                {this.state.showConfirm && (
                    <Dialog visible={true} onHide={() => (window.location.href = "/")}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                            <div style={{ textAlign: "center" }}>
                                <label style={{ fontSize: "36px" }}>Parabéns!</label>
                                <br />
                                <br />
                                <label style={{ fontSize: "22px" }}>
                                    Seu cadastro foi enviado com sucesso!
                                    <br />
                                    Para continuar siga as instruções enviadas para o endereço de
                                    email fornecido!
                                </label>
                            </div>
                            <button
                                style={{
                                    width: window.innerWidth < 768 ? "100%" : "80%",
                                    padding: "15px",
                                    fontSize: window.innerWidth < 768 ? "18px" : "20px",
                                    color: "#ffffff",
                                    backgroundColor: "var(--unnamed-color-411172)",
                                    borderRadius: "30px",
                                    marginTop: "25px",
                                }}
                                onClick={() => this.resendEmail()}
                            >
                                Reenviar Email
                            </button>
                        </div>
                    </Dialog>
                )}
            </div>
        );
    }

    responsecodes = {
        "responsecode.e19": "[E19] Senha e/ou confirma\u00e7\u00e3o inv\u00e1lida!",
        "responsecode.e20":
            "[E20] Um ou mais campos obrigat\u00f3rios n\u00e3o foram preenchidos corretamente!",
        "responsecode.e21": "[E21] Loja padr\u00e3o desconhecida!",
        "responsecode.e22": "[E22] Permiss\u00e3o para clientes n\u00e3o foi encontrada!",
        "responsecode.e23": "[E23] Token inv\u00e1lido!",
        "responsecode.e24": "[E24] Cart\u00e3o j\u00e1 em processo de ativa\u00e7\u00e3o!",
        "responsecode.e25": "[E25] Pedido de venda n\u00e3o encontrado!",
        "responsecode.e26": "[E26] Erro durante processamento do pagamento!",
        "responsecode.e27": "[E27] Email e/ou confirma\u00e7\u00e3o inv\u00e1lido!",
        "responsecode.e28": "[E28] Saldo Insuficiente !",
        "responsecode.e29": "[E29] Usu\u00e1rio possui email inv\u00e1lido!",
        "responsecode.e30": "[E30] Permiss\u00e3o para saldo n\u00e3o foi encontrada!",
        "responsecode.e31":
            "[E31] Pagamento pendente! Assim que o seu pagamento for confirmado, o processo de ativa\u00e7\u00e3o continuar\u00e1!",
        "responsecode.e32": "[E32] ",
        "responsecode.e33": "[E33] Dados n\u00e3o conferem!",
        "responsecode.e34": "[E34] Token inv\u00e1lido!",
        "responsecode.e35": "[E35] N\u00famero m\u00e1ximo de itens ultrapassado!",
        "responsecode.e36": "[E36] Usu\u00e1rio duplicado!",
        "responsecode.e37": "[E37] E-mail duplicado!",
        "responsecode.e38": "[E38] Telefone duplicado!",
        "responsecode.e39": "[E39] Documento duplicado!",
        "responsecode.e40": "[E40] Document Inv\u00e1lido!",
        "responsecode.e41": "[E40] Código Inv\u00e1lido!",
    };
}
